// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__7OpMa","unreadBadge":"styles_unreadBadge__mF5Tk","modalContent":"styles_modalContent__HyNIE","modal":"styles_modal__3VNkX"};